import { createSelector, DefaultProjectorFn, MemoizedSelector, Selector } from '@ngrx/store';
import { ISearchState } from '../interface';

export const createGetSearchResultSelector = (searchState: Selector<object, ISearchState>) => (id: string) =>
  createSelector(searchState, state => {
    if (id == null) {
      throw new Error('Can not find search endpoint with ID ' + id);
    }
    id = id.toLowerCase();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- searchState is "any" at this time
    return state[id];
  });

export const createGetSearchStateSelector = (searchState: Selector<object, ISearchState>) =>
  new DefaultSearchSelectorConverter({
    searchState: createGetSearchResultSelector(searchState)
  });
export class DefaultSearchSelectorConverter {
  constructor(
    private _selectors: {
      searchState: (id: string) => MemoizedSelector<object, any, DefaultProjectorFn<any>>;
    }
  ) {}
  get searchState() {
    return this._selectors.searchState;
  }
}
